import React, { useState } from "react";
import "./AuthModal.css";

const AuthModal = ({ onClose, onLoginSuccess }) => {
  const [mode, setMode] = useState("login"); 
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); 

  // Login
  const [loginPhone, setLoginPhone] = useState("");
  const [loginCountry, setLoginCountry] = useState("+44");

  // Sign Up
  const [signupName, setSignupName] = useState("");
  const [signupPhone, setSignupPhone] = useState("");
  const [signupCountry, setSignupCountry] = useState("+44");

  // Handle Login
  // Login
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const fullPhone = loginCountry + loginPhone; // append country code
      const response = await fetch("/php/customer-login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: fullPhone }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.status === "success") {
        onLoginSuccess(data.customer);
        onClose();
      } else {
        setError("User does not exist. Sign up instead.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  // Sign Up
  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const fullPhone = signupCountry + signupPhone;
      const response = await fetch("/php/customer-signup.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: signupName,
          phone: fullPhone,
        }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.status === "success") {
        onLoginSuccess(data.customer);
        onClose();
      } else {
        setError(data.error || "Signup failed.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <span className="auth-modal-close" onClick={onClose}>
          &times;
        </span>

        <div className="auth-modal-header">
          <h2>{mode === "login" ? "Welcome Back!" : "Create Account"}</h2>
          <p>
            {mode === "login"
              ? "Login with your phone number"
              : "Sign up to get started"}
          </p>
        </div>

        {mode === "login" ? (
          <form onSubmit={handleLogin} className="auth-form">
            <div className="phone-input-wrapper">
              <select
                value={loginCountry}
                onChange={(e) => setLoginCountry(e.target.value)}
              >
                <option value="+44">+44</option>
                <option value="+234">+234</option>
              </select>
              <input
                type="tel"
                placeholder="Phone Number"
                value={loginPhone}
                onChange={(e) => setLoginPhone(e.target.value)}
                required
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <button type="submit" disabled={loading}>
              {loading ? <span className="spinner"></span> : "Login"}
            </button>

            <p className="switch-mode">
              Don't have an account?{" "}
              <span
                className="clickable-link"
                onClick={() => {
                  setMode("signup");
                  setError("");
                }}
              >
                Sign Up
              </span>
            </p>
          </form>
        ) : (
          <form onSubmit={handleSignup} className="auth-form">
            <input
              type="text"
              placeholder="Name"
              value={signupName}
              onChange={(e) => setSignupName(e.target.value)}
              required
            />
            <div className="phone-input-wrapper">
              <select
                value={signupCountry}
                onChange={(e) => setSignupCountry(e.target.value)}
              >
                <option value="+44">+44</option>
                <option value="+234">+234</option>
              </select>
              <input
                type="tel"
                placeholder="Phone Number"
                value={signupPhone}
                onChange={(e) => setSignupPhone(e.target.value)}
                required
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <button type="submit" disabled={loading}>
              {loading ? <span className="spinner"></span> : "Sign Up"}
            </button>

            <p className="switch-mode">
              Already have an account?{" "}
              <span
                className="clickable-link"
                onClick={() => {
                  setMode("login");
                  setError("");
                }}
              >
                Login
              </span>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default AuthModal;
